import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadCrumb } from '@nationwide/internet-servicing-angular-components';
import { PolicyInfoService } from 'app/commercial/claims/services/policy-info.service';
import { environment } from 'environments/environment';
import { commercialConstants } from '../../../common/commercial-constants';
import { LoggerService } from '../../../shared/services/logger.service';
import { ClaimsDataService } from '../services/claims-data.service';
import { CommercialLoggingService } from '../services/commercial-logging.service';
@Component({
    selector: 'is-confirmation',
    templateUrl: './confirmation.component.html',
    styleUrls: ['./confirmation.component.scss'],
    standalone: false
})
export class ConfirmationComponent implements OnInit {
    breadCrumbs: BreadCrumb[];
    currentPage = 'Confirmation';
    flowName: any;
    homeIconLink = environment.NATIONWIDE.accountSummaryPage;
    isAuto = false;
    isGL = false;
    isProperty = false;
    isWC = false;
    policyType: string;
    constructor(
        public claimsDataService: ClaimsDataService,
        private router: Router,
        public policyInfoService: PolicyInfoService,
        private LOGGER: LoggerService,
        private commercialLoggingService: CommercialLoggingService
    ) { }
    checkFlow(): void {
        switch (this.flowName) {
            case 'Commercial Auto':
                this.isAuto = true;
                break;
            case 'Workers Compensation':
                this.isWC = true;
                break;
            case 'General Liability':
                this.isGL = true;
                break;
            case 'Commercial Property':
                this.isProperty = true;
                break;
            default:
                break;
        }
    }
    navigateToClaimsList(): void {
        this.commercialLoggingService.logButtonAction(this.LOGGER, this.currentPage, 'navigate-policy-claims-list', 'success', this.getLogMetadata());
        this.commercialLoggingService.updatePreviousUrlContext();
        this.router.navigate([commercialConstants.URLS.policyClaimsList]);
    }

    ngOnInit(): void {
        this.breadCrumbs = [
            {
                name: 'Package (PAK) Claims',
                link: `${environment.NATIONWIDE.accountSummaryPage}`
            }, {
                name: 'Policy Claims List',
                link: `${commercialConstants.URLS.pakClaimsList}`
            }, {
                name: 'Start a Claim',
                link: `${commercialConstants.URLS.firstNoticeOfLoss}`
            }
        ];
        this.policyType = this.claimsDataService.getClaimsPolicyType();
        this.flowName = this.claimsDataService.getFnolFlow();
        this.commercialLoggingService.logPageLoad(this.LOGGER, this.currentPage, this.getLogMetadata());
        this.checkFlow();
        this.commercialLoggingService.updatePreviousUrlContext();
    }

    private getLogMetadata(additionalFields: any = {}): any {
        return {
            policyNumber: this.claimsDataService.getClaimsPolicyNumber(),
            policyType: this.claimsDataService.getClaimsPolicyType(),
            lineOfBusiness: this.claimsDataService.getFnolFlow(),
            claimsDisplayCount: this.claimsDataService.getClaimsDisplayCount() || 'UNKNOWN',
            alphaState: this.claimsDataService.getPrimary(this.claimsDataService.getClaimsPackage()?.address)?.state || 'UNKNOWN',
            previousUrl: window.sessionStorage.getItem('previousUrl') || '',
            ...additionalFields
        };
    }
}
